var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"form-container"},[_c('PasswordLoginForm',{on:{"onSuccess":_vm.onSuccess,"goto":_vm.onGoto}}),_c('div',{staticClass:"password-login-bg"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }